<div class="row align-items-center justify-content-center">
  <div class="col col-xl-6 col-lg-8">
    <app-cards-basic title="Login mit E-Mail und Passwort"
                     description="Bitte gib Deine Zugangsdaten ein, um Dich anzumelden."
                     [loading]="isLoading">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <!-- E-Mail-Feld -->
        <mat-form-field class="w-100" appearance="fill">
          <mat-label>E-Mail</mat-label>
          <input matInput placeholder="beispiel@domain.com" formControlName="email" required>
          <mat-error *ngIf="loginForm.controls['email'].hasError('required')">
            E-Mail ist erforderlich.
          </mat-error>
          <mat-error *ngIf="loginForm.controls['email'].hasError('email')">
            Bitte gib eine gültige E-Mail-Adresse ein.
          </mat-error>
        </mat-form-field>

        <!-- Passwort-Feld -->
        <mat-form-field class="w-100" appearance="fill">
          <mat-label>Passwort</mat-label>
          <input matInput type="password" placeholder="Passwort" formControlName="password" required>
          <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
            Passwort ist erforderlich.
          </mat-error>
        </mat-form-field>

        <!-- Alert-Nachricht -->
        <app-alerts *ngIf="alertData" [alertData]="alertData"></app-alerts>

        <!-- Login-Button -->
        <button mat-flat-button color="primary"
                type="submit"
                class="bp-button bp-button--large w-100"
                [disabled]="!loginForm.valid || isLoading">
          Login
        </button>
        <p class="pt-4">Not yet registered? <a [routerLink]="['/register' | localize]">Register here</a></p>
        <p>Forgot Password? <a [routerLink]="['/password-forgot' | localize]">Get Link here</a></p>
      </form>
    </app-cards-basic>
  </div>
</div>
